import L from 'leaflet';

const TYPE_COLORS = {
  collect: '#28a745',
  customhouse: '#ffc107',
  delivery: '#007bff',
  via: '#f97316',
  default: '#6c757d',
};

const getPointTypeId = point =>
  typeof point?.type === 'string' ? point.type : point?.type?.id;

const getPointColor = ({ point, interestPointIndex, total }) => {
  const typeId = getPointTypeId(point);
  if (typeId && TYPE_COLORS[typeId]) {
    return TYPE_COLORS[typeId];
  }

  if (interestPointIndex === 0) return TYPE_COLORS.collect;
  if (interestPointIndex === total - 1) return TYPE_COLORS.delivery;

  return TYPE_COLORS.default;
};

const getPointLetter = interestPointIndex =>
  String.fromCharCode(65 + interestPointIndex);

export const createWaypointLetterIcon = ({
  point,
  interestPointIndex,
  total,
}) => {
  const color = getPointColor({ point, interestPointIndex, total });
  const letter = getPointLetter(interestPointIndex);

  return L.divIcon({
    html: `
      <div style="
        background: ${color};
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-weight: 700;
        font-size: 14px;
        border: 2px solid #fff;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
      ">${letter}</div>
    `,
    className: '',
    iconSize: [30, 30],
    iconAnchor: [15, 30],
    popupAnchor: [0, -28],
  });
};
